import React from "react";
const pointsHygiene: string[] = [
  "Espace de consultation propre et organisé",
  "Matériel à usage unique pour la Hijama",
  "Préparation rigoureuse avant chaque séance",
  "Explications complètes des mesures appliquées",
];

import hygieneImg from "../../assets/images/appImages/hygieneimage.jpg";

const HygieneSecuriteSection: React.FC = () => {
  return (
    <section className="hygiene-securite-section">
      <div className="hygiene-securite-container">
        <div className="hygiene-securite-row">
          <div className="hygiene-securite-col-text">
            <p className="hygiene-securite-eyebrow mb-3">
              HYGIÈNE &amp; SÉCURITÉ
            </p>

            <h2 className="hygiene-securite-title mb-4">
              Votre bien-être mérite un cadre propre et professionnel
            </h2>

            <p className="hygiene-securite-text mb-4">
              Fouta Bio accorde une attention particulière à la préparation
              du matériel, à l'hygiène de l'espace et aux précautions prises
              avant, pendant et après chaque prestation.
            </p>

            <ul className="hygiene-securite-list">
              {pointsHygiene.map((point, index) => (
                <li className="hygiene-securite-list-item" key={index}>
                  <span
                    className="hygiene-securite-list-icon"
                    aria-hidden="true"
                  >
                    ✓
                  </span>
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="hygiene-securite-col-image">
            <img
              src={hygieneImg}
              alt="Matériel de Hijama propre et préparé"
              className="hygiene-securite-image img-fluid"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HygieneSecuriteSection;